import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useHistory } from 'react-router-dom';

import { ButtonTypes, IconTypes, PageTypes } from 'constants/Constants';
import { removeAuthToken } from 'localStorageService';

import { Heading, Paragraph } from 'components/layout/Typography/Typography';
import Box from 'components/layout/Box/Box';
import AppHeaderNav from 'components/layout/AppHeaderNav/AppHeaderNav';
import IconButton from 'components/common/IconButton/IconButton';

import monitoringLogo from './monitoring.svg';
import styles from './AppHeader.module.scss';

import client from '../../../graphqlClient';
import { version } from '../../../../package.json';

const s = classNames.bind(styles);

const AppHeader = ({ authenticated, onIsAuthenticatedCallback }) => {
	const history = useHistory();

	const logOutRequest = () => {
		removeAuthToken();
		onIsAuthenticatedCallback();
		history.push(PageTypes.LOGIN_PAGE.path);
		client.resetStore();
	};

	const navigationClick = to => history.push(to);

	return (
		<div className={s('container')}>
			<Box className={s('innerContainer')} justifyContent={'spaceBetween'} alignItems={'center'} displayFlex>
				<Box
					justifyContent={'spaceBetween'}
					alignItems={'flexStart'}
					displayFlex
					marginTop={'1'}
					marginRight={'4'}
					onClick={() => {
						navigationClick('/');
					}}
				>
					<img
						className={s('logo')}
						src={monitoringLogo}
						alt={'quack quack'} // 🦆
					/>
					<Box marginLeft={'1'}>
						<Heading className={s('heading')} type={'h1'} marginBottom={'0'}>
							Monitoring
						</Heading>
						<Paragraph fontSize={'xs'}>{`V. ${version}`}</Paragraph>
					</Box>
				</Box>
				<AppHeaderNav authenticated={authenticated} />
				<Box marginLeft={'4'}>
					{authenticated && (
						<IconButton toolTip={'Log out'} icon={IconTypes.LOGOUT} iconColor={ButtonTypes.DARK} onClickCallback={() => logOutRequest()} />
					)}
				</Box>
			</Box>
		</div>
	);
};

AppHeader.propTypes = {
	authenticated: PropTypes.bool.isRequired,
	onIsAuthenticatedCallback: PropTypes.func.isRequired
};

export default AppHeader;
